import { ENV } from "../utils";

export class Frequency {
  baseApi = ENV.BASE_API;

  async getFrequencies(accessToken, active = true) {
    const url = `${this.baseApi}/frequencies?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createFrequency(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-frequency`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateFrequency(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-frequency/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteFrequency(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-frequency/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
